export enum RegistrationGaVersion {
  MultiRegistration = 'multi-reg',
  Replatform = 'replatform',
  LGAO = 'LGAOpromo',
}
